/**
 * Home — the story, chapter by chapter. The server writes it
 * (templates/site/home.html.twig); each chapter's module moves it.
 *
 * @module pages/home
 */

import { pageEntry } from '../lib/page-data.js';
import * as factory from '../sections/home/factory.js';
import * as finale from '../sections/home/finale.js';
import * as missions from '../sections/home/missions.js';
import * as opening from '../sections/home/opening.js';
import * as player from '../sections/home/player.js';

/**
 * The chapters that move, by section id, in reading order: the pinned
 * opening comes first, so every trigger below is measured against its pin.
 * The street has no module of its own (motion/strips.js, motion/depth.js).
 */
const CHAPTERS = [
    ['two-sides', opening],
    ['the-factory', factory],
    ['under-the-hood', player],
    ['missions', missions],
    ['both-sides', finale],
];

/** The way out of the story, always on screen while it plays ("pages/home"). */
export function rail() {
    return { skip: pageEntry('pages/home').skip };
}

export function animate() {
    CHAPTERS.forEach(([id, chapter]) => {
        const root = document.getElementById(id);

        if (root) {
            chapter.animate(root);
        }
    });
}
